<template>
  <main class="home">
    <header class="top_header">
      <div class="top_header_icon_cover"></div>
      <img alt="FitGap" title="title" class="top_header__logo" src="@/assets/toplogo.svg" />
      <h1 class="top_header__title">
        自社にぴったりのサービスを選ぶための無料診断
      </h1>
      <div>
        <p class="top_header__privacy_policy">
          <a :href="termsurl()">利用規約</a>と<a :href="policyurl()">プライバシーポリシー</a>に同意のうえ
        </p>
        <button class="top_header__start_btn btn_primary" v-on:click="gotoFreeword()">
          診断を開始
        </button>
      </div>
    </header>
    <div class="self_introduction">
      <p class="self_introduction__subtitle" v-if="false">BtoBサービス診断</p>
      <h2 class="self_introduction__header" v-on:click="resetst()">BtoBサービス診断 FitGapなら</h2>

      <div class="self_introduction__container">
        <div class="self_introduction_item">
          <img class="self_introduction_item__logo" src="@/assets/require.svg" />
          <div class="self_introduction_info">
            <h3 class="self_introduction_item__header">
              自社向けのシステム要件<span style="font-weight: initial">を整理できる</span>
            </h3>
            <p class="self_introduction_item__body" v-if="false">
              自社にとってどのような機能その他条件が必要かを整理できます。
            </p>
          </div>
        </div>
        <div class="self_introduction_item self_introduction_item--center">
          <img class="self_introduction_item__logo" src="@/assets/service.svg" />
          <div class="self_introduction_info">
            <h3 class="self_introduction_item__header">
              自社にぴったりのサービス<span style="font-weight: initial">が分かる</span>
            </h3>
            <p class="self_introduction_item__body" v-if="false">
              どのサービスが自社のシステム要件に合うかがわかります。
            </p>
          </div>
        </div>
        <div class="self_introduction_item">
          <img class="self_introduction_item__logo" src="@/assets/feature.svg" />
          <div class="self_introduction_info">
            <h3 class="self_introduction_item__header">
              各サービスの料金、強み注意点、市場シェア<span style="font-weight: initial">などを知れる</span>
            </h3>
            <p class="self_introduction_item__body" v-if="false">
              各サービスの料金、強み注意点、市場シェアなどを知ることができます。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="top_link_list__wrapper">
      <div class="top_link_list">
        <h2 class="top_link_list_header">各種テーマから診断</h2>
        <div class="top_link_list_session">
          <h3 class="top_link_list_session__header top_link_list_session--first">
            サービスカテゴリ
          </h3>
          <ul class="top_link_list_session__list">
            <template v-for="(item, index) in page.categories" :key="index">
              <li class="top_link_list_session__item">
                <a class="top_link_list_session__item_link" :href="lpsearchurl(item.id, item.title)" :title="item.title">{{
                  item.title }}</a>
                <img class="top_link_list_session__icon" src="@/assets/arrow_right.svg" />
              </li>
            </template>
            <li class="
                    top_link_list_session__item top_link_list_session__item--last
                  ">
              <a class="top_link_list_session__item_link" :href="categoryurl()" title="カテゴリ一覧">カテゴリ一覧</a>
              <img class="top_link_list_session__icon" src="@/assets/arrow_right.svg" />
            </li>
          </ul>
        </div>
        <div class="top_link_list_session" v-if="false">
          <h3 class="top_link_list_session__header top_link_list_session--first">
            キーワード
          </h3>
          <ul class="top_link_list_session__list">
            <template v-for="(item, index) in page.keywords" :key="index">
              <li class="top_link_list_session__item">
                <a class="top_link_list_session__item_link" :href="klpurl(item.getId(), item.getTitle())"
                  :title="item.getTitle()">{{ item.getTitle() }}</a>
                <img class="top_link_list_session__icon" src="@/assets/arrow_right.svg" />
              </li>
            </template>

            <li class="
                    top_link_list_session__item top_link_list_session__item--last
                  ">
              <a class="top_link_list_session__item_link" title="キーワード一覧" :href="kwurl()">その他 キーワード一覧</a>
              <img class="top_link_list_session__icon" src="@/assets/arrow_right.svg" />
            </li>
          </ul>
        </div>
      </div>

    </div>

    <ContentsFooter :pager="pager" />

    <div class="bokashi" v-if="!(aikotoba == 'fitgap') && false">
      <div class="aikotoba">
        あいことば
        <input class="aikotoba__input" v-model="aikotoba" type="text" />
      </div>
      <div style="width: 100%" v-if="false">
        <div style="width: 300px; margin: auto">
          <button v-on:click="show" class="btn_primary" style="width: 100%; margin-left: 4px">
            アクセス
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.top_header__privacy_policy a {
  color: #444545;
}

.top_header__privacy_policy a:visited {
  color: #444545;
}
</style>

<style scoped>
.home {
  min-height: 100vh;
  flex-flow: column;
  display: flex;
}

.top_link_list__wrapper {
  flex: 1;

}
</style>


<style scoped>
.bokashi {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(20px);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.aikotoba {
  width: 320px;
  height: 64px;
  margin: auto;
  margin-top: 64px;
}

.aikotoba__input {
  width: 100%;
  font-size: 24px;
  line-height: 150%;
  border-radius: 4px;
}

.aikotoba__input:focus {
  border: solid 2px #00c9c9;
  outline: none;
}
</style>
<style scoped></style>
<script>
// @ is an alias to /src

import tacklebox from "tacklebox";
import ContentsFooter from "@/components/ContentsFooter.vue";

import { HomePage } from "@/js/page/HomePage.js";

tacklebox.d("a");

export default {
  name: "HomeView",
  data() {
    return {
      aikotoba: "",
      page: new HomePage(),
    };
  },
  watch: {
    aikotoba(n, o) {
      if (o) {
        if (n) {
          //
        }
      }
      if (n == "fitgap") {
        try {
          let dt = new Date();
          localStorage.setItem('aikotoba', "" + dt.getTime());
        } catch (ex) {
          tacklebox.e(ex);
        }
      }
    }
  },
  mounted() {
    try {
      let at = localStorage.getItem('aikotoba');
      if (at) {
        let ndt = new Date();
        if ((ndt.getTime() - Number(at)) < 1000 * 60 * 5) {
          this.aikotoba = "fitgap";
        }
      }
    } catch (ex) {
      tacklebox.e(ex);
    }

    this.pager.changePage(this.page);

    document.title = "FitGap | 自社にぴったりのサービスを選ぶための無料診断 ";
  },
  beforeMount() {
    //
  },
  methods: {
    resetst() {
      try {
        localStorage.removeItem('aikotoba');
      } catch (ex) {
        tacklebox.e(ex);
      }
    },
    gotoFreeword() {
      this.$router.push({ name: "freeword" });
    },
    lpsearchurl(id) {
      return process.env.VUE_APP_SELF + "/#/search/" + id;
    },
    lpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/search/" + id + "?title=" + title;
    },
    klpurl(id, title) {
      return process.env.VUE_APP_SELF + "/#/ksearch/" + id + "?title=" + title;
    },
    categoryurl() {
      return process.env.VUE_APP_SELF + "/#/category";
    },
    kwurl() {
      return process.env.VUE_APP_SELF + "/#/keyword";
    },
    topurl() {
      return process.env.VUE_APP_SELF;
    },
    termsurl() {
      return process.env.VUE_APP_SELF + "/#/terms";
    },
    policyurl() {
      return process.env.VUE_APP_SELF + "/#/policy";
    },
    onInterview() {
      this.$router.push("keyword");
    },
  },
  components: {
    ContentsFooter,
  },
  props: {
    pager: Object,
  },
};
</script>
